import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.seek.com',
    clientDomain: 'ph.employer.seek.com',
    clientId: 'VisupHzYZNjjX5dVPwJuX3mFE2WhTRu6',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://www.jobstreet.com/about-us/contact-us-philippines/',
    },
    siteName: siteNames.employer.seek.ph,
    zone: getZoneFromSite(siteNames.employer.seek.ph),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=ph_employer_seek_com.js.map